import * as yup from 'yup';

export const initialValues = {
  password: '',
  newPassword: '',
  confirmPassword: '',
};

export const validationSchema = yup.object().shape({
  password: yup.string().required('Current Password is required'),
  newPassword: yup.string().required('New Password is required'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('newPassword'), null], 'Passwords must match')
    .required('Confirm Password is required'),
});
